export function maybe(thunk) {
    try {
        return thunk();
    }
    catch (_a) { }
}
//# sourceMappingURL=maybe.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@apollo/client/utilities/globals/maybe.js
// module id = 582
// module chunks = 4